

import { Avatar } from '../ui/Avatar'

export interface TabProps {
    id: string
    name: string
    isActive: boolean
    isPinned: boolean
    unreadCount: number
    agentId: string | null
    avatarUrl?: string | null
    onClick: () => void
    onClose: () => void
}

export function Tab({
    name,
    isActive,
    isPinned,
    unreadCount,
    agentId,
    avatarUrl,
    onClick,
    onClose
}: TabProps) {
    return (
        <div
            onClick={onClick}
            className={`
                flex items-center gap-2 px-3 py-2 cursor-pointer
                border-b-2 transition-all duration-200 min-w-0 max-w-[200px]
                ${isActive
                    ? 'border-white bg-transparent'
                    : 'border-transparent text-gray-500 hover:text-gray-300'
                }
            `}
        >
            {/* Avatar (if agent) */}
            {(agentId || avatarUrl) && (
                <div className="flex-shrink-0">
                    <Avatar
                        src={avatarUrl || undefined}
                        alt={name}
                        size="sm"
                        className="w-5 h-5" // Custom tiny size for tabs
                    />
                </div>
            )}

            {/* Tab name */}
            <span className={`text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis ${isActive ? 'text-gray-900 dark:text-white' : 'text-gray-500'}`} title={name}>
                {name.length > 18 ? `${name.substring(0, 18)}...` : name}
            </span>

            {/* Unread badge */}
            {unreadCount > 0 && (
                <span className="px-2 py-0.5 text-xs font-bold text-white bg-red-500 rounded-full">
                    {unreadCount}
                </span>
            )}

            {/* Close button (hidden if pinned) */}
            {!isPinned && (
                <button
                    onClick={(e) => {
                        e.stopPropagation()
                        onClose()
                    }}
                    className="ml-auto p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                    aria-label="Close tab"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            )}

            {/* Pin indicator */}
            {isPinned && (
                <svg className="w-4 h-4 ml-auto text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L11 4.323V3a1 1 0 011-1zm-5 8.274l-.818 2.552c-.25.78-.03 1.632.57 2.212.617.6 1.507.86 2.35.63L8 15v3a1 1 0 001 1h2a1 1 0 001-1v-3l.898.668c.843.23 1.733-.03 2.35-.63.6-.58.82-1.432.57-2.212L15 10.274v-1.968a1 1 0 10-2 0v1.968l-.818 2.552c-.25.78-.03 1.632.57 2.212.617.6 1.507.86 2.35.63L14 15v3h-4v-3l.898.668c.843.23 1.733-.03 2.35-.63.6-.58.82-1.432.57-2.212L13 10.274v-1.968a1 1 0 10-2 0v1.968z" />
                </svg>
            )}
        </div>
    )
}
